
export default function ConstructionManagementSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-[#5C1A24] rounded-full flex items-center justify-center mr-4">
                <i className="ri-hammer-line text-white text-xl"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24]" style={{ fontFamily: '"Playfair Display", serif' }}>
                Gestão de Obras
              </h2>
            </div>
            
            <div className="text-[#3F3F3F] leading-relaxed space-y-4">
              <p>
                Garantir que o projeto saia do papel com perfeição é o que nos move.
              </p>
              <p>
                Acompanhamos cada etapa da obra, coordenando equipes, fornecedores e prazos com excelência.
              </p>
              <p className="font-medium text-[#5C1A24]">
                Seu projeto entregue com qualidade, eficiência e tranquilidade.
              </p>
            </div>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                'Supervisão técnica',
                'Controle de qualidade',
                'Gestão de cronograma',
                'Coordenação de equipes'
              ].map((feature, index) => (
                <div key={index} className="flex items-center">
                  <i className="ri-check-line text-[#5C1A24] mr-2"></i>
                  <span className="text-sm text-[#3F3F3F]">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div>
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/7abc42c00b57b584a5ef41ca660301c8.jpeg"
                alt="Gestão de Obras"
                className="w-full h-80 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#5C1A24]/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
